import { ESdChangeReason, ESymbolCategory, IAction, IActionParameter, ISymbol, IWorkFlow } from "@kuika/kuika-cl-model";
import _ from "lodash";
import React from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";

export interface IWFMigrateProcessSymbolsGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild, changeReason?: ESdChangeReason) => void;
}

class WFMigrateProcessSymbolsGroup extends PureSdComponent<
  IWFMigrateProcessSymbolsGroupProps & IWithSDProps & IWithContextProp,
  any
> {
  getProcessSelectValue = () => {
    const processParam = this.props.parameters.find((x) => x.name === "ProcessDefinitionId");
    if (processParam?.symbol?.fixedValue) {
      return processParam.symbol.fixedValue;
    }
    return "";
  };

  onSelectProcess = (val: string) => {
    const params = _.cloneDeep(this.props.parameters);
    const processParam = params.find((x) => x.name === "ProcessDefinitionId");

    if (processParam) {
      if (!processParam.symbol) {
        processParam.symbol = { category: ESymbolCategory.fixed } as ISymbol;
      }
      processParam.symbol.fixedValue = val;

      const valuesToUpdate = {
        actionParameters: params
      } as IActionPanelStatesCanBeUpdatedFromChild;

      this.props.updateValues(valuesToUpdate, ESdChangeReason.ActionDescriptionChanged);
    }
  };

  render() {
    const processOptions: KuikaSelectboxOption[] = (this.props.sd.workFlowList ?? []).map(
      (wf: IWorkFlow): KuikaSelectboxOption => ({ key: wf.id, value: wf.id, label: wf.name })
    );

    return (
      <div style={{ width: "100%" }}>
        <div style={{ marginTop: 12 }} className="kuika_add_actions_properties_name">
          Process:
        </div>
        <div className="kuika_property-grid-column">
          <KuikaSelectbox
            size="sm"
            style={{ width: "100%" }}
            value={this.getProcessSelectValue()}
            onChange={this.onSelectProcess}
            className="kuika_add_actions_inputs_size"
            options={processOptions}
          />
        </div>
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const wfMigrateProcessSymbolsGroup = withContext<IWFMigrateProcessSymbolsGroupProps>(
  withSD<IWFMigrateProcessSymbolsGroupProps>(WFMigrateProcessSymbolsGroup)
);
export { wfMigrateProcessSymbolsGroup as WFMigrateProcessSymbolsGroup };
